
import $store from '../../store';

export function store(command, data = undefined, args = undefined) {
    command = command.split(':', 2);
    const commandType = command[0];
    command = command[1];

    let payload = null;

    if(args !== undefined) {
        payload = args;
    } else if(data) {
        payload = data.valueOf();
    }

    if(commandType == 'commit') {
        $store.commit(command, payload);
    } else if(commandType == 'dispatch') {
        $store.dispatch(command, payload);
    }

    return data;
}